// eslint-disable-next-line no-restricted-imports
import {
  atom,
  Provider,
  useAtom,
  useAtomValue,
  useSetAtom,
  createStore,
  type PrimitiveAtom,
} from "jotai";
import { useLayoutEffect } from "react";

import type {
  CustomFileLibraryDialogState,
  CurrentCustomFile,
  CustomFileMetadata,
  FolderMetadata,
} from "./types/customFileLibrary";

export const appJotaiStore = createStore();

export { atom, Provider, useAtom, useAtomValue, useSetAtom };

export const useAtomWithInitialValue = <
  T extends unknown,
  A extends PrimitiveAtom<T>,
>(
  atom: A,
  initialValue: T | (() => T),
) => {
  const [value, setValue] = useAtom(atom);

  useLayoutEffect(() => {
    if (typeof initialValue === "function") {
      // @ts-ignore
      setValue(initialValue());
    } else {
      setValue(initialValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [value, setValue] as const;
};

// Custom File Library Atoms
export const customFileLibraryDialogAtom = atom<CustomFileLibraryDialogState>({
  isOpen: false,
});

export const currentCustomFileAtom = atom<CurrentCustomFile>({
  id: null,
  name: "Untitled",
  lastSaved: null,
  folderId: null,
});

export const customFilesListAtom = atom<CustomFileMetadata[]>([]);

export const foldersListAtom = atom<FolderMetadata[]>([]);

// Track which folders are collapsed (folder ID -> boolean)
export const collapsedFoldersAtom = atom<Record<string, boolean>>({});
